module.exports = __webpack_public_path__ + "img/1F3C1.9d29277b.svg";